import { UI, HStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { SubscriptionSmallCardProps } from '..';
import { LateralBar } from '../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import { useSubscriptionDetailContext } from '../../../contexts/SubscriptionDetail';
import { SubscriptionInfo } from '../../SubscriptionCard/components/SubscriptionInfo';
import { SubscriptionMainInfo } from '../../SubscriptionCard/components/SubscriptionMainInfo';
import { SubscriptionTimeLimit } from '../../SubscriptionCard/components/SubscriptionTimeLimit';

export const SubscriptionSmallCardTablet: React.FC<SubscriptionSmallCardProps> = ({
  subscription,
}) => {
  const { setModalOpen, setSubscriptionSelected } = useSubscriptionDetailContext();

  const handleOpenItemDetailsModal = () => {
    setModalOpen(true);
    setSubscriptionSelected(subscription);
  };

  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy}>
      <Box p="inset.xs" w="full">
        <LateralBar
          backgroundColor="product.rendavariavel"
          borderTopLeftRadius="sm"
          borderBottomLeftRadius="sm"
        />
        <HStack justifyContent="space-between" alignItems="center" space="inline.xxxs">
          <SubscriptionMainInfo
            description={`ISIN: ${subscription.baseIsinCode}`}
            title={subscription.productDisplay}
            onDetailsPress={handleOpenItemDetailsModal}
            hasLeftovers={subscription.hasLeftovers}
            unforcedFlex
          />
          <SubscriptionInfo label="Data limite" value={subscription.limitDateFormatted} />
          <SubscriptionTimeLimit
            daysSinceDeadline={subscription.daysSinceDeadline}
            daysToDeadline={subscription.daysToSettlement}
            type={subscription.timeLimitType}
          />
          <SubscriptionInfo label="Clientes aptos" value={`${subscription.customersEligible}`} />
          <SubscriptionInfo label="Preço unitário" value={subscription.unitaryPriceFormatted} />
        </HStack>
      </Box>
    </UI.Shadow>
  );
};
